/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'printer': {
    viewBox: '0 0 32 32',
    data: `<g><rect x="12" y="24.5" width="8" height="1"/><rect x="12" y="21.5" width="8" height="1"/><rect x="12" y="27.5" width="8" height="1"/><path d="M31,8h-6V0H7v8H1v16h6v8h18v-8h6V8z M9,2h14v6H9V2z M23,30H9V20h14V30z M29,22h-4v-4H7v4H3V10h4h18h4V22z"/></g>`
  }
})
